import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

function Welcome() {
  return (
    <div className="app-container">
      <Header />
      <div className="welcome-container">
        <div className="welcome-content">
          <h1>Welcome to InPods.AI</h1>
          <p className="welcome-subtitle">
            The intelligent platform for educators and students to create, manage, and learn from educational content.
          </p>
          
          <div className="welcome-features">
            <div className="feature-card">
              <div className="feature-icon">🏫</div>
              <h3>Course Management</h3>
              <p>Create and organize courses with ease. Upload content, track progress, and manage your educational materials.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🤖</div>
              <h3>AI Assistant</h3>
              <p>Get help with content creation, summaries, and quiz generation using our advanced AI assistant.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Analytics</h3>
              <p>Track student engagement and performance with detailed analytics and insights.</p>
            </div>
          </div>
          
          <div className="welcome-cta">
            <Link to="/register" className="btn btn-primary btn-large">Get Started</Link>
            <Link to="/login" className="btn btn-outline btn-large">Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
